<template>
  <div>
    <a-form @submit="handleSubmit" :form="form" class="form">
      <a-card title="短信配置" class="card" :bordered="true">
        <a-button
          slot="extra"
          size="small"
          :loading="isSubmit"
          v-if="isEdit"
          type="primary"
          @click="handleSubmit">
          提交
        </a-button>
        <a-button slot="extra" size="small" v-if="isEdit" @click="isEdit = false" style="margin-left:15px;">取消</a-button>
        <a-button slot="extra" size="small" v-if="!isEdit" @click="isEdit = true" type="primary">编辑</a-button>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="短信签名"
              :labelCol="{lg: {span: 8}, sm: {span: 8}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit && data.aliyun_sms_signName" v-decorator="['aliyun_sms_signName',{rules: [{ required: data.aliyun_sms_signName, message: '请输入短信签名' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit && data.aliyun_sms_signName">{{ data.aliyun_sms_signName || '--' }}</span>
              <span v-if="!data.aliyun_sms_signName">********</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="ACCESS_KEY_ID"
              :labelCol="{lg: {span: 8}, sm: {span: 8}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit && data.aliyun_sms_keyId" v-decorator="['aliyun_sms_keyId',{rules: [{ required: data.aliyun_sms_keyId, message: '请输入阿里云access_key_id' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit && data.aliyun_sms_keyId">{{ data.aliyun_sms_keyId || '--' }}</span>
              <span v-if="!data.aliyun_sms_keyId">********</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="ACCESS_KEY_SECRET"
              :labelCol="{lg: {span: 8}, sm: {span: 8}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit && data.aliyun_sms_keySecret" v-decorator="['aliyun_sms_keySecret',{rules: [{ required: data.aliyun_sms_keySecret, message: '请输入阿里云access_key_secret' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit && data.aliyun_sms_keySecret">{{ data.aliyun_sms_keySecret || '--' }}</span>
              <span v-if="!data.aliyun_sms_keySecret">********</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="验证码模板"
              :labelCol="{lg: {span: 8}, sm: {span: 8}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['aliyun_sms_template_code',{rules: [{ required: data.aliyun_sms_template_code, message: '请输入模板ID' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.aliyun_sms_template_code || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="报修通知模板"
              :labelCol="{lg: {span: 8}, sm: {span: 8}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['aliyun_sms_template_repair_notice',{rules: [{ required: data.aliyun_sms_template_repair_notice, message: '请输入模板ID' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.aliyun_sms_template_repair_notice || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
    </a-form>
  </div>
</template>
<script>
import _ from 'lodash'
import { getPre, saveConfig } from '@/api/system'
import { mixin, mixinDevice } from '@/utils/mixin'
import notification from 'ant-design-vue/es/notification'
export default {
  mixins: [mixin, mixinDevice],
  components: {
  },
  created () {
    this.handlePre()
  },
  data () {
    return {
      loading: false,
      isEdit: false,
      isSubmit: false,
      form: this.$form.createForm(this),
      data: {}
    }
  },
  methods: {
    handlePre () {
      getPre({ type: 'sms' }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.data = _.get(res, 'data', {})
          this.form.setFieldsValue(this.data)
        }
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(this.data, this.form.getFieldsValue())
          this.isSubmit = true
          saveConfig(data).then(res => {
            if (_.get(res, 'code') === 200) {
              this.handlePre()
              this.isEdit = false
              this.isSubmit = false
              notification.success({
                message: '更新成功',
                description: '保存成功'
              })
            } else {
              this.isSubmit = false
              notification.warning({
                message: '更新失败',
                description: '请稍后再试'
              })
            }
          })
        }
      })
    }
  }
}
</script>
